import BodySnippet from './BodySnippet';
import HeadSnippet from './HeadSnippet';
import {
    dataLayer,
} from './utils';

const gtm = {
    dataLayer,
};
export {
    BodySnippet,
    HeadSnippet,
    gtm,
};
